module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAQCAMAAAD6fQULAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAGZQTFRF////4eHh+/v7/f39+vr6+fn5/Pz8+Pj49vb29fX139/f7u7u8vLy8fHx9/f33Nzc19fX4ODg9PT08PDw6+vr2dnZ6Ojo7e3t8/Pz3t7e2tra2NjY6enp4uLi5+fn5ubm7Ozs////3VeRvAAAACJ0Uk5T////////////////////////////////////////////AA3Qw3EAAABySURBVHjaVM5XEoMwDARQrTDF9NATSsL9L4mRZWaivzfaWYnQlDbm6JQhg3eXmkTlmGdhScLaJJHqpmbJ8+Wz9EcK3O+sioHYFQX4K4qmsqmK8SkeMcahKDXJWKdfv2TSwmgPt7LyDaH9bnPf1XL9EmAAUPQJYaKnqfYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow.png
// module id = 3Uj3
// module chunks = 1